import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const LanguageToggle = ({ currentLanguage, onLanguageChange }) => {
  const { switchLanguage } = useLanguage();
  
  const languages = [
    { code: 'fr', label: 'Français', icon: 'Languages' },
    { code: 'ar', label: 'العربية', icon: 'Languages' }
  ];

  const handleLanguageChange = (code) => {
    switchLanguage(code);
    if (onLanguageChange) {
      onLanguageChange(code);
    }
  };

  return (
    <div className="flex items-center gap-2 bg-card rounded-md p-1 shadow-warm">
      {languages?.map((lang) => (
        <button
          key={lang?.code}
          onClick={() => handleLanguageChange(lang?.code)}
          className={`
            flex items-center gap-2 px-3 py-2 rounded-md transition-smooth
            ${currentLanguage === lang?.code
              ? 'bg-primary text-primary-foreground shadow-warm'
              : 'text-muted-foreground hover:bg-muted'
            }
          `}
          aria-label={`Switch to ${lang?.label}`}
        >
          <Icon name={lang?.icon} size={16} />
          <span className="text-sm font-medium">{lang?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;